export default "__VITE_ASSET__BoceZ7sF__"